/* eslint-disable @nx/enforce-module-boundaries */
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import {
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  RouterFeatures,
  provideRouter,
  withComponentInputBinding,
  withDebugTracing,
} from '@angular/router';
import * as store from '@daas-consulting/core-frontend-store';
import { provideTelemetry } from '@daas-consulting/core-frontend-telemetry';
import {
  DataFormatterService,
  DynamicScriptLoaderService,
  QueryStringService,
} from '@daas-consulting/core-frontend-utils';
import { intl } from '@daas-consulting/production/shared/frontend/components';
import { AuthNGuard } from '@daas-consulting/security/authentication/frontend/utils';
import { environment } from '../environments/environment';
import { appModules } from './app.modules';
import { AppRoutes } from './app.routes';
import {
  AbilityServiceProvider,
  AgeGroupsServiceProvider,
  AuditDetailPageViewModelProvider,
  AuditServiceProvider,
  AuthenticationInterceptorProvider,
  AuthenticationViewModelProvider,
  ConfigurationProvider,
  HttpAuthenticationServiceProvider,
  JwtHelperServiceProvider,
  LayoutBase2PageViewModelProvider,
  LocaleIDProvider,
  PureAbilityProvider,
} from './providers';

const features: RouterFeatures[] = [
  withComponentInputBinding(),
  !environment.prod && environment.loggerEnabled
    ? withDebugTracing()
    : undefined,
]
  .filter((x) => x)
  .map((x) => x as RouterFeatures);

export const AppProviders = [
  provideHttpClient(withFetch(), withInterceptorsFromDi()),
  ...provideTelemetry({
    errorsEndpoint: `${environment.baseUrl}/telemetry/errors`,
    appName: 'app-production',
  }),
  provideRouter(AppRoutes, ...features),
  provideAnimations(),
  importProvidersFrom(CommonModule),
  importProvidersFrom(...appModules),
  DecimalPipe, // ✅ registra el pipe
  DatePipe, // ✅ si también usás date formatting
  store.EventHelper,
  QueryStringService,
  DataFormatterService,
  intl.MatPaginatorIntlProvider,

  // Fechas y formatos
  intl.NativeDateFormatsProvider,
  intl.MatDateLocaleProvider,

  provideDateFnsAdapter(intl.NATIVE_DATE_FORMATS),
  AuthNGuard,

  AgeGroupsServiceProvider,
  AbilityServiceProvider,
  AuthenticationViewModelProvider,
  AuthenticationInterceptorProvider,
  ConfigurationProvider,
  HttpAuthenticationServiceProvider,
  JwtHelperServiceProvider,
  LayoutBase2PageViewModelProvider,
  LocaleIDProvider,
  PureAbilityProvider,
  AuditDetailPageViewModelProvider,
  AuditServiceProvider,
  DynamicScriptLoaderService,
];
